import { render, staticRenderFns } from "./HomeNewsletter.vue?vue&type=template&id=b5b6ddf4&scoped=true&"
import script from "./HomeNewsletter.vue?vue&type=script&lang=js&"
export * from "./HomeNewsletter.vue?vue&type=script&lang=js&"
import style0 from "./HomeNewsletter.vue?vue&type=style&index=0&id=b5b6ddf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b6ddf4",
  null
  
)

export default component.exports